import * as React from 'react';

import { GallerySidebarLayout } from 'shared/components/GalleryRedesigned/components/GallerySidebar';

import { FavoriteButtonContainer } from './parts';

export const GallerySidebarContainer: React.FC = () => {
  return (
    <GallerySidebarLayout
      title={<div>1-комн. кв., 50,3 м², 7/19 эт</div>}
      favoriteButton={<FavoriteButtonContainer />}
      price={<div>13 000 000 ₽</div>}
      buttons={<div>buttons</div>}
      author={<div>author</div>}
    />
  );
};
